import * as THREE from 'three'

import Mediator from '../../globals/mediator'

import Config from '../../config'

import emitter from '../../emitter'

import OrbitControls from './orbitcontrols.js'

const DEMIPI = Math.PI / 2

const PI = Math.PI

const DOUBLEPI = Math.PI * 2

const QUARTER_PI = Math.PI / 4

let zero = new THREE.Vector3()

let frustumSize = 1;

class Camera extends THREE.OrthographicCamera {

	constructor(fov, aspect, near, far) {

		super(frustumSize * aspect / - 2, frustumSize * aspect / 2, frustumSize / 2, frustumSize / - 2, near, far)
		 
		// super(fov, aspect, near, far)

		this.position.set( 0,  0,  0.1)

		emitter.on('resize', this.resize.bind(this))

		this.addEvents()

		this.originalZ = this.position.z



	}



	addControls(dom) {

		this.controls = new OrbitControls(this, dom)

	}

	update() {


	}

	resize(w, h) {

		this.left   = - w / 2;

		this.right  =   w / 2

		this.top    =   h / 2;

		this.bottom = - h / 2;

		this.zoom = Math.max(w / 2, h / 2);

		this.updateProjectionMatrix();
		this.updateMatrix();
	
	}

	addEvents() {

		emitter.on('update', this.update.bind(this))
	}

}

// let camera = new Camera(40, window.innerWidth / window.innerHeight, 1, 100)
let camera = new Camera(10, window.innerWidth / window.innerHeight, 0.1, 100)
export default camera;


// WEBPACK FOOTER //
// ./src/scripts/Trail/modules/camera/index.js